import {store} from '../../redux/store';
import {openFiltersModal, hideFiltersModal} from './reducer';
import {FiltersModalMessage} from '../../interfaces/connected-components/filtersModal';
import {fakeFilters} from '../../assets/static/apple';
import Config from 'react-native-config';

export const showFiltersModal = ({
  onSubmit,
  filters,
  filtersValues,
}: FiltersModalMessage) => {
  const {currentUser} = store.getState().auth || {};
  let tempFilters = filters;
  if ((currentUser?.email || '').trim().toLowerCase() === Config.APPLE_EMAIL) {
    tempFilters = fakeFilters;
  }

  store.dispatch(
    openFiltersModal({
      onSubmit,
      filters: tempFilters,
      filtersValues,
    }),
  );
};

/**
 * This function close Filters modal
 */
export const closeFiltersModal = () => {
  store.dispatch(hideFiltersModal());
};
